<template>
  <vue-apex-charts
    v-if="renderChart"
    :height="height"
    width="300px"
    type="pie"
    :options="options"
    :series="series">
  </vue-apex-charts>
</template>

<script>
import _ from 'lodash';
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'ChartAnalyticsPie',
  components: { VueApexCharts },
  props: {
    analytics: {
      type: Array,
      required: true,
    },
    height: {
      type: String,
      default: 'auto',
    },
    type: {
      type: String,
      default: 'categories',
    },
    baseColor: {
      type: String,
      default: '#068B86',
    },
  },
  mounted() {
    // Flatten all categories into 1 big array and then call countBy
    const counts = _.countBy(_.flatten(_.map(this.analytics, a => a[this.type])));
    this.options.labels = Object.keys(counts);
    this.series = Object.values(counts);
    this.renderChart = true;
  },
  data() {
    return {
      renderChart: false,
      options: {
        legend: {
          show: true,
          position: 'top',
          offsetY: 0,
          labels: {
            fontSize: 12,
          },
        },
        labels: this.labels,
        chart: {
          id: 'vuechart-example',
          type: 'pie',
          // This is needed to make the legend text white
          foreColor: 'whitesmoke',
        },
        stroke: {
          show: true,
          width: 0,
        },
        theme: {
          monochrome: {
            enabled: true,
            color: this.baseColor,
            shadeTo: 'light',
            shadeIntensity: 0.65,
          },
        },
      },
      series: this.counts,
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
